import Head from 'next/head'
import React, {Component} from 'react'
import {getStaticPageTitle, socialMeta} from '../../data/meta'
import {getEnvHostAddress} from '../../../shared/env'

class CMSDrivenPage extends Component {
  render () {
    const {pageData, title, canonicalPath} = this.props
    return (
      <div className='CMSDrivenPage' role='region' aria-label={title}>
        <Head>
          <title>{getStaticPageTitle(title)}</title>
          <link rel='canonical' href={getEnvHostAddress() + canonicalPath} />
          {socialMeta()}
        </Head>
        <div className='CMSDrivenPage__content'>
          <h1 className='CMSDrivenPage__title'>{title}</h1>
          <div className='CMSDrivenPage__body'>
            {pageData}
          </div>
        </div>
      </div>
    )
  }
}

CMSDrivenPage.defaultProps = {}

export default CMSDrivenPage



// WEBPACK FOOTER //
// ./client/pageComponents/CMSDrivenPage/CMSDrivenPage.js